import { render, staticRenderFns } from "./Launch.vue?vue&type=template&id=2d6b6437&scoped=true&lang=pug"
import script from "./Launch.vue?vue&type=script&lang=js"
export * from "./Launch.vue?vue&type=script&lang=js"
import style0 from "./Launch.vue?vue&type=style&index=0&id=2d6b6437&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6b6437",
  null
  
)

export default component.exports